import * as h from 'h'
import routes from 'routes'
import StoreProvider from 'StoreProvider'

export default () =>
  h.h(StoreProvider, null, routes)



// WEBPACK FOOTER //
// ./resources/assets/js/App.js